
import {
    Button,
    Box,
    Container,
    Flex,
    Heading,
    Image,
    Stack,
    Text,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    Input,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    FormControl,
    FormLabel,
    FormHelperText,
    chakra, useColorModeValue, VisuallyHidden, Link, useToast, FormErrorMessage
} from "@chakra-ui/react";

import {
    Table,
    Thead,
    Tbody,
    Tfoot,
    Tr,
    Th,
    Td,
    TableCaption,
    TableContainer,
} from '@chakra-ui/react'

import {Header as Nav} from "../header/Header";
import {Footer} from "../footer/Footer";
import {Form, redirect, useNavigate} from "react-router-dom";
import {FormControlEvo} from "../forms/chakra/FormControlEvo";
import {EmailInputEvo} from "../forms/chakra/inputs/EmailInputEvo";
import React, {useEffect, useRef, useState} from "react";
import Cookies from "js-cookie";
import {useEvoContext} from "../../context/evo.context";
import LoginDataProvider from "../dataProviderEvo/login-data-provider";
import RegisterDataProvider from "../dataProviderEvo/register-data-provider";
import {emptyFormData, emptyFormDataPurchase, fieldNameAndLabels} from "../../infrastructure/utils/formUtils";
import {ScreenContainer} from "../container/ScreenContainer";
import {ROUTE_MAIN} from "../../App";
import {AntiSpamYearInputEvo} from "../forms/chakra/inputs/AntiSpamYearInputEvo";
import getFormValues from "../forms/values/formValues";
import formValidator from "../forms/validate/validate";
import {FormLabelEvo} from "../forms/chakra/label/FormLabelEvo";


export default function Register() {

    const {isLoggedIn, setIsLoggedIn} = useEvoContext();
    const navigate = useNavigate();

    let fieldNamesAndLabels = fieldNameAndLabels;

    useEffect(() => {

        if(isLoggedIn){
            navigate('/');
        }

    }, []);


    const formRef = useRef(null);
    const toast = useToast();

    const [formData, setFormData] = useState(emptyFormData);

    // let fieldNamesAndLabels = fieldNameAndLabels;

    const [errors, setErrors] = useState({});

    const validateForm = () => {

        const form = formRef.current;
        if (form) {

            const currentFormData = getFormValues(form);

            const {isValid, validationErrors} = formValidator(currentFormData, fieldNamesAndLabels);


            let isValidVar = isValid;


            if (isValid && formData.password !== formData.confirmPassword) {
                isValidVar = false;
                validationErrors.confirmPassword = "Hesla se neshodují.";
            }

            setErrors(validationErrors);

            if (isValidVar) {
                return true;
            }
        }
        return false;
    };

    // Handle form input changes
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Handle form submission
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault(); // Prevent default form submission

        if (validateForm()) {

            let headers = {
                // "Auth-login-email": formData.email
                "email": formData.email,
                "password": formData.password
            }
            //
            let params = {
                // "Auth-login-email": formData.email
                "email": formData.email,
                "password": formData.password,
                "name":formData.name,
                "surname": formData.surname
            }

            let dp = new RegisterDataProvider();
            dp.register(params, headers).then((res) => {

                let errorTitle =  'Registrace se nezdařila',
                    errorText = 'Zkuste akci zopakovat.';

                if (res.status === 'OK') {

                    // setIsLoggedIn(true);

                    if(res.errors.length === 0){
                        toast({
                            // title: 'Úspěch',
                            description: 'Registrace byla úspěšná, zkontrolujte prosím svůj e-mail pro další pokyny.',
                            status: 'success',
                            duration: 5000,
                            isClosable: true,
                            position: "top"
                        });

                        navigate(ROUTE_MAIN);

                    } else {
                        toast({
                            title: errorTitle,
                            description: res.errors[0] + ' ' + errorText,
                            status: 'error',
                            duration: 5000,
                            isClosable: true,
                            position: "top"
                        });
                    }

                    //
                } else {

                    toast({
                        title: errorTitle,
                        description: res.errors[0] + ' ' + errorText,
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                        position: "top"
                    });
                }
            });

        }
    };


    useEffect(() => {

        toast.closeAll();

        if (Object.keys(errors).length > 0) {

            const errorList = Object.values(errors).map((error, index) => (
                <li key={index}>{error}</li>
            ));

            // const errorMessage = Object.values(errors).join('\n');
            toast({
                title: 'Prosíme vyplňte povinné údaje',
                description: (
                    <Box as="ul" ml={4}>
                        {errorList}
                    </Box>
                ),
                status: 'error',
                duration: 5000,
                isClosable: true,
                position: "top"
            });
        }

    }, [errors]);

    return (
        <Box bg={useColorModeValue('#f9f9f9', '#1a202c')}>
            <Nav />
            <ScreenContainer mb={"250px"}>
                <Stack direction={{ base: 'column', md: 'column' }}>
                    <Flex flex={1} align={'center'} justify={'center'}>

                        <Stack direction={{base: 'column', md: 'column'}}>
                            <Flex flex={1} align={'center'} justify={'center'}>
                                <Stack spacing={6} w={'full'}>
                                    <chakra.h1 textAlign={'center'} fontSize={'4xl'} py={10} fontWeight={'bold'}>
                                        Registrace
                                    </chakra.h1>
                                </Stack>
                            </Flex>

                        </Stack>
                    </Flex>

                </Stack>
                <Box bg={"white"} mt={"5"}  padding={"10"} mt={5} boxShadow={"md"} borderRadius={10}>
                    <Form ref={formRef} method={"post"} onSubmit={handleSubmit} >
                        <FormControlEvo>
                            <EmailInputEvo validity={errors.email} defaultVal={formData.email} handleChange={handleChange} />
                        </FormControlEvo>

                        <FormControlEvo>
                            <FormLabelEvo mandatory={true}>{fieldNameAndLabels.name.label}</FormLabelEvo>
                            <Input  defaultValue={formData.name} type={"text"} name={fieldNamesAndLabels.name.name} onInput={handleChange} />
                        </FormControlEvo>

                        <FormControlEvo>
                            <FormLabelEvo mandatory={true}>{fieldNameAndLabels.surname.label}</FormLabelEvo>
                            <Input  defaultValue={formData.surname} type={"text"} name={fieldNamesAndLabels.surname.name} onInput={handleChange} />
                        </FormControlEvo>

                        <FormControlEvo isInvalid={errors.password} mt={4}>
                            <FormLabelEvo mandatory={true} htmlFor={fieldNameAndLabels.password.name}>{fieldNameAndLabels.password.label}</FormLabelEvo>
                            <Input
                                id={fieldNameAndLabels.password.name}
                                type='password'
                                name={fieldNameAndLabels.password.name}
                                placeholder='Zadejte heslo'
                                value={formData.password || ''}
                                onChange={handleChange}
                            />
                            <Text my={1} fontSize={"sm"} color='gray' fontWeight={"normal"}>{"Musí obsahovat alespoň 1 malé písmeno, 1 velké písmeno, 1 číslo a mít délku alespoň 8 znaků"}</Text>
                            {errors.password && (
                                <FormErrorMessage>{errors.password}</FormErrorMessage>
                            )}
                        </FormControlEvo>

                        <FormControl isInvalid={errors.confirmPassword} mb={4}>
                            <FormLabel htmlFor="confirmPassword">{"Potvrzení hesla"}</FormLabel>
                            <Input
                                id="confirmPassword"
                                type="password"
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                placeholder="Potvrďte své nové heslo."
                            />
                            <FormErrorMessage>{errors.confirmPassword}</FormErrorMessage>
                        </FormControl>

                        <AntiSpamYearInputEvo validity={errors.antiSpam} defaultVal={formData.antiSpam} handleChange={handleChange}  />

                        <Stack spacing={3} my={5} alignContent={"center"} alignItems={"center"}>
                            <Text fontSize='1xl'>Registrací souhlasíte se <Link textDecoration="underline" href={"poou.pdf"} >
                                zpracováním osobních údajů.
                            </Link>
                            </Text>
                        </Stack>

                        <Button colorScheme='pink' variant='solid' type={"submit"}>Registrovat se</Button>
                    </Form>

                    <Stack spacing={3} fontWeight={"bold"} alignContent={"center"} alignItems={"center"}>
                        <Text fontSize='xl'>Už máte účet? <Link  fontSize="xl" href={"prihlaseni"} color="blue.500">
                            Přihlásit se
                        </Link>
                        </Text>
                    </Stack>
                </Box>
            </ScreenContainer>
            <Footer />
        </Box>
    )
}
